import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '@services';
import { environment } from '@env/environment';

@Component({
    selector: 'msc-subscription-success',
    templateUrl: './subscription-success.component.html'
})
export class SubscriptionSuccessComponent implements OnInit {

    state: 'loading' | 'success' | 'error' = 'loading';

    constructor(
        private route: ActivatedRoute,
        private http: HttpClient,
        private authService: AuthService,
    ) {}

    ngOnInit(): void {
        const sessionId = this.route.snapshot.queryParamMap.get('session_id');

        if (!sessionId) {
            this.state = 'error';
            return;
        }

        this.fetchLoginToken(sessionId);
    }

    private fetchLoginToken(sessionId: string, attempt = 1): void {
        const maxAttempts = 5;
        const retryDelayMs = 3000;

        const base = environment.envVar.API_URL.endsWith('/')
            ? environment.envVar.API_URL.slice(0, -1)
            : environment.envVar.API_URL;

        this.http.get<{ access_token: string; refresh_token: string; token_type: string }>(
            `${base}/subscriptions/login-token?session_id=${encodeURIComponent(sessionId)}`
        ).subscribe({
            next: (response) => {
                this.authService.createCookies({
                    access_token: response.access_token,
                    refresh_token: response.refresh_token,
                } as any);
                this.state = 'success';
                // Hard redirect (full page reload) so Angular re-initializes
                // with the new auth cookies — same pattern as LoginComponent SSO flow.
                setTimeout(() => {
                    window.location.href = '/login/company';
                }, 1500);
            },
            error: (error: HttpErrorResponse) => {
                // 409: the purchase was made for an account that already existed. The API does not
                // hand out its session (the checkout email does not prove ownership), so there is
                // nothing to wait for: show the "subscription confirmed, please sign in" state.
                if (error.status === 409) {
                    this.state = 'error';
                    return;
                }

                if (attempt < maxAttempts) {
                    setTimeout(() => this.fetchLoginToken(sessionId, attempt + 1), retryDelayMs);
                } else {
                    this.state = 'error';
                }
            }
        });
    }
}
